<script>
  /** @type {string} */
  export let letter;
</script>

<div class="letter-group">
  <span class="letter-group--label">{letter}</span>
</div>
